import { ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { M000C030CheckoutWrapperComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';
import ServiceFormContactStepComponent from './service-form-contact-step/service-form-contact-step.component';
import ServiceFormListStepComponent from './service-form-list-step/service-form-list-step.component';
import ServiceFormThanksStepComponent from './service-form-thanks-step/service-form-thanks-step.component';

@Component({
    selector: 'app-service-form-page',
    standalone: true,
    imports: [
        ServiceFormListStepComponent,
        ServiceFormContactStepComponent,
        ServiceFormThanksStepComponent,
        M000C030CheckoutWrapperComponent,
    ],
    templateUrl: './service-form-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class ServiceFormPageComponent {
    store = inject(Store);
    completed = signal(false);
}
